module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO42FlujoCajaEnRojo.0ed03f7.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO42FlujoCajaEnRojo.mp4
// module id = 768
// module chunks = 1